import React from "react";
import CoursePath from "./CoursePath/CoursePath";
import { useQuery } from "@tanstack/react-query";
import { getAllChapters, callWithAuth } from "../../api/Api";
import { GetAllChaptersRequest } from "@shared_types";
import Title from "../Title";
import { LoadingPage } from "@/pages/LoadingPage";
import ContinueButton from "../Buttons/ContinueButton";
import { useCurrentCourse } from "@/hooks/useSelectedCourse";
import { useNavigate } from "react-router-dom";

const CourseView: React.FC = () => {
  const { currentCourseID, isCurrentCourseLoading } = useCurrentCourse();
  const navigate = useNavigate();

  const courseInfoQuery = useQuery({
    queryKey: ["courseInfo", currentCourseID],
    queryFn: () => {
      const data: GetAllChaptersRequest = {
        courseId: currentCourseID || 1,
      };
      return callWithAuth(getAllChapters, data);
    },
  });

  const course = courseInfoQuery.data?.course;
  const chapters = courseInfoQuery.data?.chapters || [];
  const courseTitle = course?.title || "Select a course";

  if (isCurrentCourseLoading || courseInfoQuery.isLoading)
    return (
      <div className="fixed inset-2 flex items-center justify-center">
        <LoadingPage showText={false} />
      </div>
    );

  return (
    <div
      className={`flex flex-col w-full justify-start overflow-scroll gap-4 no-scrollbar`}
    >
      <div className="flex flex-row items-center">
        <Title text={courseTitle} />{" "}
      </div>
      <div className="w-full h-auto overflow-scroll z-0 no-scrollbar">
        {chapters.length > 0 ? (
          <CoursePath chapters={chapters} />
        ) : (
          <div className="flex flex-col relative items-center justify-between w-full h-48 p-4 bg-white rounded-xl border border-[var(--color-grey-light)]">
            <div className="text-xl font-semibold text-[var(--color-grey)]">
              No course selected
            </div>
            <div className="text-base font-normal text-[var(--color-grey)]">
              Browse our courses to find the perfect one for you
            </div>
            <ContinueButton
              text="Browse courses"
              className="max-w-[300px] mt-10"
              onClick={() => {
                navigate("/home/courses");
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CourseView;
